export class GradientConfig {
  static readonly layout = 'vertical'; // vertical, horizontal
  static readonly subLayout = ''; // horizontal-2
  static isCollapse_menu = false; // true
  static readonly layoutType = 'menu-light'; // menu-dark, menu-light, dark
  static readonly header_back_color = 'header-blue'; // header-blue, header-red, header-purple, header-info, header-dark, header-orange
  static readonly isRtlLayout = false; // true
  static readonly nav_fixed_layout = true; // false
  static readonly header_fixed_layout = true; // false
  static readonly isBoxLayout = false; // true
}
